import React from "react";
import styled from "styled-components";
import { AboutUsText } from "../../Lang/AboutUs";
import Call from '../../assets/call.svg'
import Email from '../../assets/email.svg'
import Location from '../../assets/location.svg';
import IG from  '../../assets/instagram.svg'
import LI from '../../assets/linkedin.svg'
import Map from "./Map";

const Style = styled.div`
    display: grid;
    background-color: var(--body-2);
    grid-template-columns: repeat(2 , calc(50% - 25px));
    border-radius: var(--border-radius-2);
    padding: 2rem ;
    margin: auto var(--padding );
    gap: 20px;
    .connect-title{ 
        font-size : 1.25rem;
        font-weight: 700;
        text-align: right;
    }
    .connect{
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: right;
        position: relative;
        background-color: var(--body-2);
        .connect-text{
            font-size: 1rem;
            font-weight: 500;
            line-height: 2rem;
            .about{
                display: flex;
                flex-direction: row;
                margin-top: 2rem ;
                color: var(--gray-6);
                .svg-abt{
                    display: flex;
                    position: relative;
                    margin-left: 1.5rem;
                    width: 2rem;
                }
            }
        }
        .connect-way{
            display:flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            width: 100%;
            margin: 1rem 0;
            gap: 18px;
            .more-way{
                color: var(--gray-6);
            }
            .way{
                border: 1px solid var(--gray-3);
                border-radius: var(--border-radius-4);
                box-shadow: var(--shadow-13);
                padding:0.4rem 1.25rem;
                color: var(--gray-6);
                cursor: pointer;
                text-decoration: none;
                display: flex;
                flex-direction: row-reverse;
                align-items: center;
                justify-content: center;
                width: 4.5rem;
                gap: 4px;
                .svg-abt{
                    display: flex;
                    position: relative;
                    width: 1.5rem;
                    aspect-ratio: 1;
                }
                span{
                    padding-top: 6px;
                    font-size: 0.75rem ;
                    font-weight: 500;
                }
            }
        }
    }
    @media screen and (max-width: 800px) {
        margin: 2rem 0;
        display: flex;
        flex-direction: column-reverse;
        padding:1rem var(--padding);
        border-radius: 0;
        width: calc(100% - var(--width-padding));
        .connect{
            margin-bottom: 1rem ;
            grid-template-columns: 1fr;
            .svg-desc{
                inset: -1.5rem auto auto calc(50% - 2.5rem);
                width: 3rem;
                padding:0 1rem;
            }
            .connect-text .about {
                margin-top: 1rem;
                .svg-abt{
                    width: 1.5rem;
                }
            }
            .connect-way{
                .more-way{
                    display: none;
                }
                .way{
                    justify-content: center;
                    width: 5.5rem;
                    margin: 0.5rem;
                }           
            }
        }
        .map{
            padding: 0;
            margin-top: 2rem;
            grid-row: 2;
        }
    }
`

export const LocationData =()=>{
    return(
        <Style >
            <div className='connect'>
                <span className='connect-title'>راه‌های ارتباطی</span>
                <div className='connect-text'>
                    <div className='about'>
                        <img src={Call} alt={'call'} className='svg-abt'/>
                        <span style={{direction: "ltr"}}>{AboutUsText.phone1}</span> 
                    </div>
                    <div className='about'>
                        <img src={Email} alt={'email'} className='svg-abt'/>
                        <span>{AboutUsText.email}</span>
                    </div>
                    <div className='about'>
                        <img src={Location} alt={'location'} className='svg-abt'/>
                        <span>{AboutUsText.address}</span>
                    </div>
                </div>
                <div className='connect-way'>
                    <span className='more-way'>سایر راه‌های ارتباطی :  </span>
                    <a href = "tel: 02188503854" className='way'>
                        <img src={Call} alt={'call'} className='svg-abt'/>
                        <span>Call</span>
                    </a>
                    <a  className='way' href={AboutUsText.linkedin} >
                        <img src={LI} alt={'linkedin'} className='svg-abt'/>
                        <span>Linkedin</span>   
                    </a>
                    <a  className='way' href={AboutUsText.instagram}>
                        <img src={IG} alt={'instagram'} className='svg-abt'/>
                        <span>Instagram</span>
                    </a>
                </div>
            </div>
            <div className='connect'>
                <div className='map'>
                    <Map/>
                </div>
                
            </div>
        </Style>
    )

}